<div class='m-0 p-0 bg-dark m-0 p-0'>
  <div class='d-flex mt-0 mb-0 ml-5 mr-5 pt-5 pb-5'>
    <div>
      <img src='images/public_footer_logo.png'>
    </div>
   
    <div class='d-flex flex-column ml-5'>
      <h5 class='text-white'>Contact</h5>
      <div class='d-flex mt-2'>
        <div>
          <img src='images/loc-map-icon.png'>
        </div>
        
        <div class='text-muted ml-3'>
          Softline Data, Inc.<br>
          5252 St. Albans Bay Rd.<br>
          Excelsior, MN 55331
        </div>
      </div>
      <div class='d-flex mt-2'>
        <div>
          <img src='images/envelop_icon.png'>
        </div>
        
        <div class='text-muted ml-3'>
          publicalert@softlinedata.com
        </div>
      </div>
      <div class='d-flex mt-2'>
        <div>
          <img src='images/telphn_icon.png'>
        </div>
        
        <div class='text-muted ml-3'>
          (800) 657-0880
        </div>
      </div>
    </div>
  </div>
</div>
<div class='d-flex m-0 p-5 text-white' style='background-color: #770b0f;'>
 &copy {new Date().getFullYear()} Public Alert All rights reserved.
</div>